import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { TaskService } from 'app/services/task.service';
import { RemindersPopover } from './reminders.popover';

@Component({
    selector: 'app-reminders',
    templateUrl: './reminders.component.html',
    styleUrls: ['./reminders.component.scss'],
    standalone: false
})
export class RemindersComponent implements OnInit
{
    @Input() taskService: TaskService;
    @ViewChild('popover') popover!: HTMLIonPopoverElement;

    skeleton: boolean = true;
    refreshing: boolean = false;

    constructor(
        public modalController: ModalController,
        private popoverController: PopoverController
    ) { }

    ngOnInit()
    {
        this.skeleton = true;
        this.taskService.setRemindersComponentOpen(true);
    }

    public dismissModal(button: any)
    {
        // Dismiss the top modal returning some data object
        this.modalController.dismiss({
            'result': button
        });
        this.taskService.setRemindersComponentOpen(false);
    }

    dismissAllReminders()
    {
        this.refreshing = true;
        this.taskService.dismissAllTaskReminders()
            .subscribe({
                next: x =>
                {
                    this.refreshing = false;
                    this.modalController.dismiss();
                    this.taskService.setRemindersComponentOpen(false);
                },
                error: error =>
                {
                    this.refreshing = false;
                    console.log(error);
                }
            });
    }


    async presentPopover(ev: any)
        {
            ev.stopPropagation();
            const popover = await this.popoverController.create({
                component: RemindersPopover,
                event: ev,
                translucent: true,
            });
    
            popover.onDidDismiss().then(
                (d: any) => this.handlePopoverDismiss(d)
            );
            return await popover.present();
        }
    
        handlePopoverDismiss = ({ data }) =>
        {
            switch (data)
            {
                case "dismissAll":
                    this.dismissAllReminders();
                    break;
            }
        }


}
